// extracted by mini-css-extract-plugin
export default {"Cart_light_button":"CartShippingForm_Cart_light_button__OHC8s","Cart_dark_button":"CartShippingForm_Cart_dark_button__GjxNX"};